import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	failToLoadTitleNonFianl: {
		id: 'software-releases-version-detail-issue-list.error-view.fail-to-load-title-non-fianl',
		defaultMessage: "Can't load issues",
		description: 'Title that is shown when loading issue list is failed',
	},
	refreshButtonLabel: {
		id: 'software-releases-version-detail-issue-list.error-view.refresh-button-label',
		defaultMessage: 'Refresh page',
		description:
			'Description that is shown when loading issue list is failed to let users refresh the page to retry',
	},
	errorImageAlt: {
		id: 'software-releases-version-detail-issue-list.error-view.error-image-alt',
		defaultMessage: 'Image that shows loading issues failed.',
		description: 'Alt text of the error image.',
	},
});
